// Module
var code = "<div class=\"dms-helptext-content\">\r\n    <i class=\"far fa-question-circle fa-2x fa-pull-right\"></i>\r\n    #= data #\r\n</div>";
// Exports
export default code;